import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { LogoFull } from '../components/Logo';
import { api } from '../api/client';

export default function ResetPassword() {
  const [searchParams]            = useSearchParams();
  const token                     = searchParams.get('token');
  const navigate                  = useNavigate();
  const [password, setPassword]   = useState('');
  const [confirm, setConfirm]     = useState('');
  const [loading, setLoading]     = useState(false);
  const [success, setSuccess]     = useState(false);
  const [error, setError]         = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 8) return setError('Password must be at least 8 characters.');
    if (password !== confirm) return setError('Passwords do not match.');
    setLoading(true);
    try {
      await api.auth.resetPassword(token, password);
      setSuccess(true);
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      setError(err.message || 'Something went wrong.');
    } finally {
      setLoading(false);
    }
  };

  const s = styles;

  if (!token) return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.logo}><LogoFull /></div>
        <div style={s.errorBox}>This reset link is invalid. Please request a new one.</div>
        <Link to="/forgot-password" style={s.backLink}>Request new link</Link>
      </div>
    </div>
  );

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.logo}><LogoFull /></div>
        <h1 style={s.title}>Choose a new password</h1>
        {success ? (
          <div>
            <div style={s.successBox}>Password updated! Redirecting you to login...</div>
            <Link to="/login" style={s.backLink}>Go to login</Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            {error && <div style={s.errorBox}>{error}</div>}
            <label style={s.label}>New password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              style={s.input}
              placeholder="Minimum 8 characters"
              required
              autoFocus
            />
            <label style={s.label}>Confirm new password</label>
            <input
              type="password"
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
              style={s.input}
              placeholder="Repeat your password"
              required
            />
            <button type="submit" style={s.btn} disabled={loading}>
              {loading ? 'Updating...' : 'Set new password'}
            </button>
            <Link to="/login" style={s.backLink}>← Back to login</Link>
          </form>
        )}
      </div>
    </div>
  );
}

const styles = {
  page: { minHeight: '100vh', background: '#17171e', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px' },
  card: { background: '#1a1a24', border: '1px solid #2a2a38', borderRadius: 16, padding: '40px', width: '100%', maxWidth: 420 },
  logo: { marginBottom: 28, display: 'flex', justifyContent: 'center' },
  title: { fontSize: 24, fontWeight: 800, fontFamily: 'Syne, sans-serif', color: '#f0f0f4', margin: '0 0 20px' },
  label: { display: 'block', fontSize: 13, fontWeight: 600, color: '#b0b0c4', marginBottom: 6 },
  input: { width: '100%', padding: '10px 14px', background: '#17171e', border: '1px solid #2a2a38', borderRadius: 8, color: '#f0f0f4', fontSize: 15, marginBottom: 18, boxSizing: 'border-box', outline: 'none', fontFamily: 'DM Sans, sans-serif' },
  btn: { width: '100%', padding: '12px', background: '#FFD93D', color: '#1a1a24', border: 'none', borderRadius: 8, fontWeight: 700, fontSize: 15, fontFamily: 'Syne, sans-serif', cursor: 'pointer', marginBottom: 16 },
  backLink: { display: 'block', textAlign: 'center', fontSize: 14, color: '#7a7a94', textDecoration: 'none', marginTop: 8 },
  successBox: { background: 'rgba(82,255,138,0.08)', border: '1px solid rgba(82,255,138,0.2)', borderRadius: 8, padding: '14px 16px', color: '#52ff8a', fontSize: 14, lineHeight: 1.6, marginBottom: 20 },
  errorBox: { background: 'rgba(255,82,82,0.08)', border: '1px solid rgba(255,82,82,0.2)', borderRadius: 8, padding: '14px 16px', color: '#ff5252', fontSize: 14, marginBottom: 16 },
};
